import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightsContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Placeholder = styled.div`
  width: 18px;
  height: 18px;
  padding-right: 3px;
`;

export const Count = styled.div<{ $isDisabled?: boolean }>`
  ${typographyV2.bodyXs};
  color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--text-disabled)' : 'var(--text-soft)'};
  width: 15px;
  height: 16px;
`;
